import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  StackDivider,
  Text,
  useDisclosure,
  useToast,
  VStack,
} from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { clearComments } from '../../stores/slices/comments/commentsSlice';
import {
  deleteGoalItem,
  getGoalCategories,
  getGoalItem,
} from '../../stores/slices/goals/goalsActions';
import AddComment from './AddComment';
import Comments from './Comments';

const GoalComments = ({ setOpenComments, goal, openEdit, goalCategoryId }) => {
  const {
    isOpen: isOpenComment,
    onOpen: onOpenComment,
    onClose: onCloseComment,
  } = useDisclosure();

  const {
    isOpen: isOpenAlert,
    onOpen: onOpenAlertAlert,
    onClose: onCloseAlert,
  } = useDisclosure();

  const [isDeleting, setIsDeleting] = useState(false);
  const cancelRef = useRef();
  const dispatch = useDispatch();
  const toast = useToast();

  useEffect(() => {
    onOpenComment();
  }, [onOpenComment]);

  useEffect(() => {
    dispatch(clearComments());
    dispatch(getGoalItem({ goalId: goal.id, goalCategoryId: goalCategoryId }));
    // eslint-disable-next-line
  }, []);

  const onDeleteItem = async () => {
    setIsDeleting(true);
    await dispatch(deleteGoalItem({ goalId: goal.id }));
    await dispatch(getGoalCategories());
    onCloseAlert();
    setIsDeleting(false);
    toast({
      description: 'Item has been deleted',
      colorScheme: 'primary',
      status: 'success',
      duration: 3000,
      isClosable: true,
      position: 'bottom-right',
      variant: 'primary',
    });
  };

  return (
    <React.Fragment>
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpenComment}
        size={'xl'}
        onClose={() => {
          onCloseComment();
          setOpenComments(false);
        }}
        scrollBehavior={'inside'}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Item Comments</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack divider={<StackDivider />} spacing={'4'}>
              <Stack
                justifyContent={'space-between'}
                direction={{ base: 'column', lg: 'row' }}
                w={'full'}
                spacing={4}
              >
                <Text fontSize={'md'}>{goal.text}</Text>
                <ButtonGroup size="sm" isAttached>
                  <Button
                    onClick={() => {
                      openEdit();
                      onCloseComment();
                      setOpenComments(false);
                    }}
                  >
                    Edit
                  </Button>
                  <Button
                    bg={'red.400'}
                    _hover={{
                      color: 'red.400',
                      bg: 'transparent',
                    }}
                    onClick={onOpenAlertAlert}
                  >
                    Delete
                  </Button>
                </ButtonGroup>
              </Stack>
              <VStack maxH={'450px'} w={'full'}>
                <Comments commentType={'goal'} commentListId={goal.id} />
              </VStack>
            </VStack>
          </ModalBody>

          <ModalFooter>
            <AddComment commentType={'goal'} commentListId={goal.id} />
          </ModalFooter>
        </ModalContent>
      </Modal>
      <AlertDialog
        isOpen={isOpenAlert}
        leastDestructiveRef={cancelRef}
        onClose={onCloseAlert}
        blockScrollOnMount={false}
        closeOnOverlayClick={isDeleting ? false : true}
        closeOnEsc={isDeleting ? false : true}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Item
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure? If you delete this record, it'll be gone forever.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                ref={cancelRef}
                variant={'outline'}
                onClick={onCloseAlert}
                disabled={isDeleting}
              >
                Cancel
              </Button>
              <Button
                bg={'red.400'}
                _hover={{
                  color: 'red.400',
                  bg: 'transparent',
                }}
                onClick={() => onDeleteItem()}
                ml={3}
                isLoading={isDeleting}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </React.Fragment>
  );
};

export default GoalComments;
